import { recordBootSummary } from "~/lib/telemetry";

const PHASES = [
  "client-created",
  "session-restored",
  "crypto-init-start",
  "crypto-init-done",
  "sync-start",
  "rooms-first",
  "timeline-first",
] as const;

export type BootPhase = (typeof PHASES)[number];

export interface BootEntry {
  phase: BootPhase;
  ms: number;
}

const observed = new Map<BootPhase, number>();
let reported = false;
const baseline = Date.now();

function stamp(): number {
  if (typeof performance !== "undefined" && typeof performance.now === "function") {
    return performance.now();
  }
  return Date.now() - baseline;
}

export function markBoot(phase: BootPhase): void {
  if (!PHASES.includes(phase)) return;
  if (observed.has(phase)) return;
  observed.set(phase, stamp());
  if (typeof performance !== "undefined" && typeof performance.mark === "function") {
    performance.mark(`chat:boot:${phase}`);
  }
}

export function bootSummary(): BootEntry[] {
  return [...observed.entries()]
    .sort((a, b) => a[1] - b[1])
    .map(([phase, t]) => ({ phase, ms: Math.round(t) }));
}

export function reportBoot(): void {
  if (reported) return;
  reported = true;
  const summary = bootSummary();
  console.info("chat boot", summary.map(({ phase, ms }) => `${phase}=${ms}`).join(" "));
  recordBootSummary(summary);
}

export function __resetBootTimingForTest(): void {
  observed.clear();
  reported = false;
}
